import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home/index.vue"),
  },
  // 支付成功页面
  {
    path: "/charging/paysuccess.html",
    name: "pay-success",
    component: () => import("@/views/PaySuccess.vue"),
  },
  // 支付失败页面
  {
    path: "/charging/payfail.html",
    name: "pay-fail",
    component: () => import("@/views/PayFail.vue"),
  },
  // Stripe 支付跳转 - 将 /c/pay/:sessionId 重定向到 Stripe Checkout
  {
    path: "/c/pay/:sessionId",
    name: "stripe-checkout",
    beforeEnter() {
      // 直接从浏览器原始 URL 替换域名，避免 Vue Router 对 hash 解码导致重复
      const originalUrl = window.location.href;
      const stripeUrl = originalUrl.replace(
        window.location.origin,
        "https://checkout.stripe.com"
      );
      window.location.replace(stripeUrl);
    },
    component: () => import("@/views/Home/index.vue"),
  },
  // 通配符路由 - 捕获所有其他路径到 Home 页面
  {
    path: "/:pathMatch(.*)*",
    name: "redirect",
    component: () => import("@/views/Home/index.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

export default router;
